/* @flow */
import { fork } from 'redux-saga/effects';
import routerSaga from './router/saga';

export default function* saga() {
  yield fork(routerSaga);
}



// WEBPACK FOOTER //
// ./src/core/sagas.js